export function membershipGroups(state) {
  return state.membership.membershipGroups.data
}

export function memberships(state) {
  return state.membership.memberships
}

export function membership(state) {
  return state.membership.membership
}

export function membershipPendingAccessRequests(state) {
  return state.membership.pendingAccessRequests
}

export function membershipGetAccessRequestFromApprovalQueue(state) {
  return (AccessRequest) => {
    return _.find(state.membership.accessRequestApprovalQueue, {uuid: AccessRequest.uuid})
  }
}

export function membershipSubscription(state) {
  return state.membership.membership.subscription
}

/**
 * @param state
 * @return {boolean}
 */
export function membershipIsMembershipReportRunning(state) {
  return state.membership.membershipReports.running
}

/**
 * @param state
 * @return {array}
 */
export function membershipGetMembershipReports(state) {
  return state.membership.membershipReports.data
}

/**
 * @param state
 * @return {array}
 */
export function membershipGetAvailableReportColumns(state) {
  return state.membership.membershipReports.availableColumns
}

/**
 * @param state
 * @return {array}
 */
export function membershipGetAvailableReportFilters(state) {
  return state.membership.membershipReports.availableFilters
}

/**
 * @param state
 * @return {array}
 */
export function membershipGetMembershipReport(state) {
  return state.membership.membershipReport
}

export function totalMembershipCalendarGroups(state) {
  let total = 0;

  for (let i = 0; i < state.membership.membershipGroups.data.length; i++) {
    total += +state.membership.membershipGroups.data[i]['attributes']['list_inside_calendar_events'];
  }

  return total;
}